import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-container-module',
  templateUrl: './container-module.component.html',
  styleUrls: ['./container-module.component.css']
})
export class ContainerModuleComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
